"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpFormCheckbox = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const form_checkbox_html_1 = __importDefault(require("./form-checkbox.html"));
const form_input_base_1 = require("./form-input-base");
let ItpFormCheckbox = class ItpFormCheckbox extends (0, vue_property_decorator_1.Mixins)(form_input_base_1.FormInputBase) {
    inline;
    indeterminate;
    isSwitch;
    plain;
};
exports.ItpFormCheckbox = ItpFormCheckbox;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormCheckbox.prototype, "inline", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormCheckbox.prototype, "indeterminate", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormCheckbox.prototype, "isSwitch", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], ItpFormCheckbox.prototype, "plain", void 0);
exports.ItpFormCheckbox = ItpFormCheckbox = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_checkbox_html_1.default,
        inject: {
            componentContext: 'componentContext',
            formContext: { default: null }
        }
    })
], ItpFormCheckbox);
//# sourceMappingURL=form-checkbox.js.map